module.exports = __webpack_public_path__ + "static/media/LY.2178201b.svg";